import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { http } from "@/lib/http";

export function useJourney() {
  const qc = useQueryClient();
  const query = useQuery({
    queryKey: ["journey"],
    queryFn: async () => (await http.get("/journey/state")).data,
    staleTime: 30_000,
  });
  const dismiss = useMutation({
    mutationFn: (stepId) => http.post(`/journey/dismiss/${stepId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["journey"] }),
  });
  const restore = useMutation({
    mutationFn: (stepId) => http.post(`/journey/restore/${stepId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["journey"] }),
  });
  const markDone = useMutation({
    mutationFn: (stepId) => http.post(`/journey/mark/${stepId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["journey"] }),
  });
  return { ...query, dismiss, restore, markDone };
}
